// extracted by mini-css-extract-plugin
module.exports = {"card":"TaskGrid_card__YvoXa","gatingLabel":"TaskGrid_gatingLabel__szbXa"};